import {CONSTANTS} from '@/constants';
import { functions } from '@/functions';

export const orderform_functions = {

    data: function () {
        return {
            orderform:null,
            orderform_file_name:null,
            orderform_file_code:null,
            orderform_insert_code:null,
            orderform_php_file_name:null,
            orderform_php_file_code:null,
            orderform_php_insert_code:null,
        };
    },

    computed: {
    },

    methods: {
        enableOrderForm: function (orderform_id, onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('orderform/' + orderform_id + '/enable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        disableOrderForm: function (orderform_id, onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('orderform/' + orderform_id + '/disable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        loadOrderForm: function (orderform_id, onSuccess=null, param) {
            this.httpPrepare();
            this.$http.get(this.apiurl('orderform/' + orderform_id )).then(function (response) {
                response = this.httpSuccess(response);
                this.orderform = response.payload.orderform;
                this.orderform_file_name = response.payload.file_name;
                this.orderform_file_code = response.payload.file_code;
                this.orderform_insert_code = response.payload.insert_code;
                this.orderform_php_file_name = response.payload.php_file_name;
                this.orderform_php_file_code = response.payload.php_file_code;
                this.orderform_php_insert_code = response.payload.php_insert_code;

                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        saveOrderForm: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('orderform/'+this.orderform.id+'/save'), this.orderform).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                this.setLatestOrderForm(this.orderform.id);
            }, this.httpError)
        },

        deleteOrderForm: function (orderform_id, onSuccess=null, param) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('orderform/' + orderform_id + '/delete' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        latestTarifOrderFormClass: function (tarif) {
            return this.isLatest('App\\Models\\OrderForm', orderform.id) ? 'latest' : '';
        },

        setLatestOrderForm: function (id) {
            this.setLatest('App\\Models\\OrderForm', id);
        },

        createOrderForm: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.post(this.apiurl('orderform/create' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        }
    }
};

